import type { SavedFilter, SavedFilterGroup } from '@/types/SavedFilter'

export const vendorCreatedFilterId = 'vendor-created'
export const vendorCreatedFilter = (
  group = false,
): SavedFilter | SavedFilterGroup => ({
  _id: vendorCreatedFilterId,
  icon: 'store-alt',
  isSystemFilter: true,
  isLocked: true,
  name: 'Vendor created',
  filter: {
    isVendor: true,
  },
  queryString: '',
  ...(group ? { children: [] } : {}),
})

export const ALL_FILTER_ID = 'all'

export const allFilter = (group = false): SavedFilterGroup | SavedFilter => ({
  _id: ALL_FILTER_ID,
  icon: 'list',
  isDefault: true,
  isLocked: true,
  isSystemFilter: true,
  name: 'All shipments',
  filter: {},
  queryString: '',
  ...(group ? { children: [] } : {}),
})
